import { ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import AtInputLabel from '../atoms/AtInputLabel';
import AtMailBox from '../atoms/AtMailBox';

/** 属性定義 */
type Props = {
  children: ReactNode;
  id: string;
  name: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  defaultValue?: string;
  autoComplete?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  register?: UseFormRegisterReturn;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const MlLabeledMailBox = ({
  children,
  id,
  name,
  className,
  labelClassName,
  inputClassName,
  defaultValue,
  autoComplete,
  placeholder,
  disabled,
  maxLength,
  minLength,
  register
}: Props) => {
  return <div className={`mllabeledmailbox ${className}`}>
      <div className='flex'>
        <AtInputLabel className={labelClassName} htmlFor={id}>
          {children}
        </AtInputLabel>
        <AtMailBox name={name} id={id} defaultValue={defaultValue} className={inputClassName} autoComplete={autoComplete} placeholder={placeholder} disabled={disabled} maxLength={maxLength} minLength={minLength} register={register} />
      </div>
    </div>;
};
/** 初期値の設定 */
MlLabeledMailBox.defaultProps = {
  className: '',
  labelClassName: '',
  inputClassName: '',
  defaultValue: null,
  autoComplete: null,
  placeholder: null,
  disabled: false,
  maxLength: null,
  minLength: null,
  register: null
};
export default MlLabeledMailBox;